import { PropsWithChildren } from 'react';

import { StyledCheckboxContent, StyledCheckboxName } from './StyledCheckboxContent';

type CheckboxContentProps = PropsWithChildren<{
   readonly firstName: string;
   readonly lastName: string;
}>;

const CheckboxContent = (props: CheckboxContentProps): JSX.Element => {
   return (
      <StyledCheckboxContent>
         <StyledCheckboxName>
            {props.firstName} {props.lastName}
         </StyledCheckboxName>
         {props.children}
      </StyledCheckboxContent>
   );
};

export { CheckboxContent };
